import React, { useEffect, useState } from 'react'
import SelectUC from '../../../components/Form/SelectUC'
import { Col, Row, Typography, message, Form } from 'antd'
import InputUC from '../../../components/Form/InputUC'
import useDropdown from '../context/useDropdown'
import BtnEditUC from '../../../components/Form/BtnEditUC'
import BtnDeleteUC from '../../../components/Form/BtnDeleteUC'
import ButtonUC from '../../../components/buttonUC'
import HeaderBarAdd from '../headerBarAdd'
import ProfesLicense from './profesLicense'
import { MODE, filterIsDeleted } from '../constant'
import AutoCompleteUC from '../../../components/Form/AutoCompleteUC'

const Education = ({ props }) => {
    const {
        form,
        rcProfileEdu,
        setRcProfileEdu,
        rcDeletedData,
        setRcDeletedData } = props

    const { Text } = Typography
    const [mode, setMode] = useState(MODE.VIEW) //view, edit
    const { ddlYear, ddlDegree, ddlCertificate, ddlField, getDDLLabel, ddlInstitute } = useDropdown()
    const [isReq, setReq] = useState(false)
    const isMobile = window.innerWidth <= 992
    const instituteWatch = Form.useWatch('edu_institute', form);
    const degreeWatch = Form.useWatch('edu_degree', form);
    const certificateWatch = Form.useWatch('edu_certificate', form);
    const fieldWatch = Form.useWatch('edu_field', form);

    useEffect(() => {
        setReq(mode === MODE.EDIT)
    }, [mode])

    const handleAdd = () => {
        console.log('handleAdd')
        // new
        let newRow = {
            sort: 1,
            year: null,
            institute: null,
            degree: null,
            certificate: null,
            field: null,
            gpa: '',
            otherInstitute: '',
            otherDegree: '',
            otherCertificate: '',
            otherField: '',
        }

        if (rcProfileEdu && rcProfileEdu.length > 0) {
            const max = Math.max(...rcProfileEdu.map(o => o.sort))
            newRow = {
                ...newRow,
                sort: max + 1,
            }
        }

        setForm(newRow)
        setMode(MODE.EDIT)
    }

    const setForm = (record) => {

        form.setFieldsValue({
            edu_sort: record.sort,
            edu_year: record.year,
            edu_institute: record.institute,
            edu_degree: record.degree,
            edu_certificate: record.certificate,
            edu_field: record.field,
            edu_gpa: record.gpa,
            otherInstitute: record.otherInstitute,
            otherDegree: record.otherDegree,
            otherCertificate: record.otherCertificate,
            otherField: record.otherField,
        })
    }

    const handleEdit = (record) => {
        console.log('handleEdit', record)
        // setReq(true)
        if (record) {
            setForm(record)
            setMode(MODE.EDIT)
        }
    }

    const handleDelete = (record) => {
        if (record.id) {
            // เก็บ Record ที่ลบ
            setRcDeletedData([...rcDeletedData, { id: record.id, tableName: 'appProfileEdu' }])
        }
        setRcProfileEdu(rcProfileEdu.filter(r => r.sort !== record.sort))
    }

    const handleCancel = () => {
        setMode(MODE.VIEW)
        // setReq(false)
    }

    const handleSubmit = () => {
        const dataPreSubmit = {
            sort: form.getFieldValue('edu_sort'),
            year: form.getFieldValue('edu_year'),
            institute: form.getFieldValue('edu_institute'),
            degree: form.getFieldValue('edu_degree'),
            certificate: form.getFieldValue('edu_certificate'),
            field: form.getFieldValue('edu_field'),
            gpa: form.getFieldValue('edu_gpa'),
            otherInstitute: form.getFieldValue('otherInstitute'),
            otherDegree: form.getFieldValue('otherDegree'),
            otherCertificate: form.getFieldValue('otherCertificate'),
            otherField: form.getFieldValue('otherField'),
        }
        const dataColValidate = [
            { caption: "กรุณาเลือกปีที่สำเร็จการศึกษา", columnName: "edu_year" },
            { caption: "กรุณาเลือกสถานศึกษา", columnName: "edu_institute" },
            { caption: "กรุณาเลือกระดับการศึกษา", columnName: "edu_degree" },
            { caption: "กรุณาเลือกวุฒิการศึกษา", columnName: "edu_certificate" },
            { caption: "กรุณาเลือกสาขาวิชา", columnName: "edu_field" },
            { caption: "กรุณากรอกคะแนนเฉลี่ย", columnName: "edu_gpa" },
            { caption: "กรุณากรอก อื่นๆ (โปรดระบุ)", columnName: "otherInstitute" },
            { caption: "กรุณากรอก อื่นๆ (โปรดระบุ)", columnName: "otherDegree" },
            { caption: "กรุณากรอก อื่นๆ (โปรดระบุ)", columnName: "otherCertificate" },
            { caption: "กรุณากรอก อื่นๆ (โปรดระบุ)", columnName: "otherField" }
        ]
        let isValidate = false
        dataColValidate.forEach(el => {
            const _isValidate = checkValidateDraft(el)
            isValidate = isValidate ? isValidate : (_isValidate ?? false)
        })

        if (isValidate) {
            message.warning('กรุณากรอกข้อมูลประวัติการศึกษา');
            // setReq(false)
            return false
        } else {
            const row = rcProfileEdu.filter(item => item.sort === dataPreSubmit.sort)
            if (row && row.length > 0) {
                setRcProfileEdu(rcProfileEdu.map((obj) => obj.sort === dataPreSubmit.sort ? { ...obj, ...dataPreSubmit } : obj))
            } else {
                setRcProfileEdu([...rcProfileEdu, dataPreSubmit])
            }
            // setReq(false)
            setMode(MODE.VIEW)
        }
    }

    const checkValidateDraft = (e) => {
        const _data = form.getFieldValue([e.columnName]);
        const _other = {
            otherInstitute: instituteWatch,
            otherDegree: degreeWatch,
            otherCertificate: certificateWatch,
            otherField: fieldWatch,
        };

        const _validate = !_data || _data === '';
        const isOtherField = _other[e.columnName] === 'other';
        const isField = Object.keys(_other).includes(e.columnName);

        if (_validate && (isOtherField || !isField)) {
            form.setFields([
                {
                    name: [e.columnName],
                    errors: [e.caption],
                },
            ]);
            return true;
        }

        return false;
    };

    const handleChangeEdu = (ev, columnName) => {
        const _edu = {
            edu_institute: 'otherInstitute',
            edu_degree: 'otherDegree',
            edu_certificate: 'otherCertificate',
            edu_field: 'otherField',
        };

        if (_edu[columnName]) {
            form.setFieldsValue({ [_edu[columnName]]: null });
        }
    };

    const handleChange = (e) => {
        let inputValue = e.target.value;
        const reg = /^-?\d*(\.\d*)?$/;
        if (!(reg.test(inputValue) || inputValue === '' || inputValue === '-')) {
            inputValue = inputValue.length > 0 ? (inputValue.substring(0, inputValue.length - 1)) : ''
        } else {
            if (inputValue.length === 2 && !(inputValue.length === 2 && inputValue.substring(1, 2) === '.')) {
                const val1 = inputValue.substring(0, 1)
                const val2 = inputValue.substring(1, 2)
                inputValue = val1.concat('.').concat(val2)
            }
        }
        form.setFieldsValue({ edu_gpa: inputValue });
    }

    const handleBlur = (e) => {
        const inputValue = parseFloat(e.target.value);
        if (inputValue) {
            if (inputValue > 4.00) {
                form.setFieldsValue({ edu_gpa: '4.00' });
            } else {
                form.setFieldsValue({ edu_gpa: inputValue.toFixed(2) });
            }
        } else {
            form.resetFields(['edu_gpa']);
        }
    }

    const setFormEdit = (e) => {
        let edu_degree = null, edu_certificate = null, edu_field = null, edu_institute = null
        if (ddlDegree.filter(filterIsDeleted)?.length > 0) {
            edu_degree = ddlDegree.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('edu_degree'))
        }
        if (ddlCertificate.filter(filterIsDeleted)?.length > 0) {
            edu_certificate = ddlCertificate.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('edu_certificate'))
        }
        if (ddlField.filter(filterIsDeleted)?.length > 0) {
            edu_field = ddlField.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('edu_field'))
        }

        form.setFieldsValue({
            edu_degree: edu_degree ? edu_degree.value : form.getFieldValue('edu_degree'),
            edu_certificate: edu_certificate ? edu_certificate.value : form.getFieldValue('edu_certificate'),
            edu_field: edu_field ? edu_field.value : form.getFieldValue('edu_field'),
            edu_institute: form.getFieldValue('edu_institute')
        })
    }

    const FormView = ({ data }) => {
        const _year = getDDLLabel(ddlYear, data.year)
        const _institute = data.institute === 'other' ? `${data.otherInstitute} (อื่น ๆ)` : getDDLLabel(ddlInstitute, data.institute)
        const _degree = data.degree === 'other' ? `${data.otherDegree} (อื่น ๆ)` : getDDLLabel(ddlDegree, data.degree)
        const _field = data.field === 'other' ? `${data.otherField} (อื่น ๆ)` : getDDLLabel(ddlField, data.field)
        const _certificate = data.certificate === 'other' ? `${data.otherCertificate} (อื่น ๆ)` : getDDLLabel(ddlCertificate, data.certificate)
        const maxWidth = isMobile ? '200px' : '120px';
        return (
            <>
                <Row className="py-2 p-3">
                    <Col xs={24} md={4} className='px-2 flex items-center'>
                        <Text
                            className='text-institute line-clamp-1 color-secondary1'
                            style={{ maxWidth: maxWidth, wordBreak: 'break-all' }}
                            title={_institute}
                        > {_institute}</Text>
                    </Col>
                    <Col xs={24} md={4} className='px-2 flex items-center'>
                        <Text
                            className='text-degree color-gray6 line-clamp-1'
                            style={{ maxWidth: maxWidth, wordBreak: 'break-all' }}
                            title={_degree}
                        >{_degree}</Text>
                    </Col>
                    <Col xs={24} md={4} className='px-2 flex items-center'>
                        <Text
                            className='text-certificate color-gray6 line-clamp-1'
                            style={{ maxWidth: maxWidth, wordBreak: 'break-all' }}
                            title={_certificate}
                        >{_certificate}</Text>
                    </Col>
                    <Col xs={24} md={4} className='px-2 flex items-center'>
                        <Text
                            className='text-field color-gray6 line-clamp-1'
                            style={{ maxWidth: maxWidth, wordBreak: 'break-all' }}
                            title={_field}
                        >{_field}</Text>
                    </Col>
                    <Col xs={24} md={2} className='px-2 flex items-center'>
                        <Text className='text-year'>{_year}</Text>
                    </Col>
                    <Col xs={24} md={2} className='px-2 flex items-center'>
                        <Text className='text-gpa'>{data.gpa}</Text>
                    </Col>
                    <Col xs={24} md={4} className='px-2'>
                        <div className="flex justify-end">
                            <BtnEditUC disabled={data.isCanNotEdit === true} handleEdit={() => handleEdit(data)} />
                            <BtnDeleteUC disabled={data.isCanNotDelete === true} handleDelete={() => handleDelete(data)} />
                        </div>
                    </Col>
                </Row>
            </>
        )
    }

    const FormEdit = () => {
        setFormEdit()
        return (
            <>
                <Row className="py-2">
                    <Col span={0} className={'hidden'}>
                        <Text name={'edu_sort'}></Text>
                    </Col>
                    <Col xs={24} md={24} className='px-2'>
                        <Row className="py-2">
                            <Col xs={24} md={16}>
                                <SelectUC
                                    required={isReq}
                                    label='สถานศึกษา'
                                    name={'edu_institute'}
                                    optionValues={ddlInstitute.filter(filterIsDeleted)}
                                    onChange={(ev) => handleChangeEdu(ev, 'edu_institute')}
                                    showSearch={true}
                                />
                            </Col>
                            <Col xs={24} md={8} className={`${isMobile ? 'py-2 px-0' : 'px-2'}`}>
                                <InputUC
                                    required={instituteWatch === 'other'}
                                    disabled={instituteWatch !== 'other'}
                                    showPlaceholder={instituteWatch === 'other'}
                                    label='กรณีเลือกอื่น ๆ (โปรดระบุ)'
                                    name={'otherInstitute'}
                                    maxLength={100} />
                            </Col>
                        </Row>
                        <Row className="py-2">
                            <Col xs={24} md={16}>
                                <SelectUC
                                    required={isReq}
                                    label='ระดับการศึกษา'
                                    name={'edu_degree'}
                                    optionValues={ddlDegree.filter(filterIsDeleted)}
                                    onChange={(ev) => handleChangeEdu(ev, 'edu_degree')}
                                    showSearch={true}
                                />
                            </Col>
                            <Col xs={24} md={8} className={`${isMobile ? 'py-2 px-0' : 'px-2'}`}>
                                <InputUC
                                    required={degreeWatch === 'other'}
                                    disabled={degreeWatch !== 'other'}
                                    showPlaceholder={degreeWatch === 'other'}
                                    label='กรณีเลือกอื่น ๆ (โปรดระบุ)'
                                    name={'otherDegree'}
                                    maxLength={100} />
                            </Col>
                        </Row>
                        <Row className="py-2">
                            <Col xs={24} md={16}>
                                <SelectUC
                                    required={isReq}
                                    label='วุฒิการศึกษา'
                                    name={'edu_certificate'}
                                    optionValues={ddlCertificate.filter(filterIsDeleted)}
                                    onChange={(ev) => handleChangeEdu(ev, 'edu_certificate')}
                                    showSearch={true}
                                />
                            </Col>
                            <Col xs={24} md={8} className={`${isMobile ? 'py-2 px-0' : 'px-2'}`}>
                                <InputUC
                                    required={certificateWatch === 'other'}
                                    disabled={certificateWatch !== 'other'}
                                    showPlaceholder={certificateWatch === 'other'}
                                    label='กรณีเลือกอื่น ๆ (โปรดระบุ)'
                                    name={'otherCertificate'}
                                    maxLength={100} />
                            </Col>
                        </Row>
                        <Row className="py-2">
                            <Col xs={24} md={16}>
                                <SelectUC
                                    required={isReq}
                                    label='สาขาวิชา'
                                    name={'edu_field'}
                                    optionValues={ddlField.filter(filterIsDeleted)}
                                    onChange={(ev) => handleChangeEdu(ev, 'edu_field')}
                                    showSearch={true}
                                />
                            </Col>
                            <Col xs={24} md={8} className={`${isMobile ? 'py-2 px-0' : 'px-2'}`}>
                                <InputUC
                                    required={fieldWatch === 'other'}
                                    disabled={fieldWatch !== 'other'}
                                    showPlaceholder={fieldWatch === 'other'}
                                    label='กรณีเลือกอื่น ๆ (โปรดระบุ)'
                                    name={'otherField'}
                                    maxLength={100} />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={24} md={8} className='px-2'>
                        <SelectUC required={isReq} label='ปีที่สำเร็จการศึกษา' name={'edu_year'} optionValues={ddlYear} />
                    </Col>
                    <Col xs={24} md={8} className='px-2'>
                        <InputUC required={isReq} label='คะแนนเฉลี่ย' maxLength={4} name={'edu_gpa'}
                            onChange={handleChange} onBlur={handleBlur} />
                    </Col>
                    <Col span={24} className='px-2 flex justify-end py-2' >
                        <ButtonUC className='btn-clear mr-3' onClick={() => handleCancel()}>ยกเลิก</ButtonUC>
                        <ButtonUC className='btn-custom ml-3' onClick={() => handleSubmit()}>บันทึก</ButtonUC>
                    </Col>
                </Row>
            </>
        )
    }

    return (
        <div className="education content-block p-3">
            <div className="block-title">ประวัติการศึกษา</div>
            <HeaderBarAdd title={'ประวัติการศึกษา'} handleAdd={handleAdd} disabled={mode === 'edit'} />
            {mode === 'view' && rcProfileEdu && rcProfileEdu.length > 0 ?
                <>
                    {rcProfileEdu.map((item, index) => {
                        return (
                            <FormView key={index} data={item} />
                        )
                    })}
                </>
                : <>{mode === 'edit' && <FormEdit />}</>}
            <Row className='py-2'>
                <ProfesLicense props={props} />
            </Row>
        </div>
    )
}

export default Education